'use client';

import { GuestGuard } from 'src/auth/guard';
import { useResponsive } from 'src/hooks/use-responsive';
import AuthClassicLayout from 'src/layouts/auth/classic';

type Props = {
  children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  const mdUp = useResponsive('up', 'md');
  return (
    <GuestGuard>
      <AuthClassicLayout width={mdUp ? '70%' : '90%'}>{children}</AuthClassicLayout>
    </GuestGuard>
  );
}
